import {
    Button,
    Flex,
    FormControl,
    Tag,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    Link,
    Checkbox,
    Select, Textarea,
    extendTheme,
    ChakraProvider,
    Box
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { Link as ReactLink, useHistory } from 'react-router-dom';
import { FocusError } from '../../components/FocusError';
import SemRegistros from '../../components/SemRegistros';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { motivoFunc } from '../../../helpers/Funcionalidades'
import { Group } from '../Criancas/Group';

import MotivoSituacaoService from "../../../main/services/MotivoSituacaoService";

const CadastrarMotivoSituacao = () => {

    document.title = 'MCA - Motivo de Situação - Cadastrar'
    let history = useHistory();

    const { roleKeycloack } = useAuthProvider();
    const [descricaoCount, setDescricaoCount] = useState(0);
    const [conceitoCount, setConceitoCount] = useState(0);

    const theme = extendTheme({
        components: {
            Checkbox: {
                baseStyle: {
                    control: {
                        bg: "#FFF",
                        _checked: {
                            bg: "rgb(49, 130, 206)"
                        }
                    }
                }
            }
        }
    });

    const validate = (values) => {
        const errors = {};

        if (!values.tipoSituacaoId || values.tipoSituacaoId === "" || values.tipoSituacaoId.trim() === "") {
            errors.tipoSituacaoId = "Tipo de motivo de situação é obrigatório!";
        }

        if (!values.descricao || values.descricao === "" || values.descricao.trim() === "") {
            errors.descricao = "Descrição é obrigatória!";
        }

        if (!values.conceito || values.conceito === "") {
            errors.conceito = "Conceito é obrigatório!";
        }

        return errors;
    };

    return roleKeycloack && roleKeycloack.includes(motivoFunc.motivoCadastrar) ? (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex
                flexDir="row"
                justifyContent="space-between"
            >

                <Heading fontSize="large">
                    Cadastrar Motivo de Situação
                </Heading>
                <Link as={ReactLink}
                    to="/motivo-situacao/lista"
                    _hover={{ textDecoration: "none" }}
                >
                    <Button colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Link>
            </Flex>

            <Formik
                validate={validate}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    descricao: "",
                    tipoSituacaoId: "",
                    riscoVida: [],
                    extincaoPoderFamiliar: [],
                    conceito: "",
                }}
                onSubmit={(values, actions) => {
                    setTimeout(() => {
                        const {
                            riscoVida,
                            descricao,
                            tipoSituacaoId,
                            conceito,
                            extincaoPoderFamiliar
                        } = values;

                        const valuesToSend = {
                            conceito,
                            motivoSituacao: descricao,
                            riscoVida:
                                riscoVida.includes("Possui")
                                    ?
                                    "S"
                                    :
                                    "N"
                            ,
                            extincaoPoderFamiliar:
                                extincaoPoderFamiliar.includes("Possui")
                                    ?
                                    "S"
                                    :
                                    "N"
                            ,
                            tipoSituacaoId:
                                tipoSituacaoId === "1" ? 1 :
                                    tipoSituacaoId === "2" ? 2 : ""

                        }

                        MotivoSituacaoService.novoMotivoSituacao(valuesToSend).then((res) => {
                            Swal.fire({
                                title: 'Sucesso!',
                                'text': 'Registro cadastrado com sucesso!',
                                icon: 'success',
                                confirmButtonText: 'Continuar',
                                confirmButtonColor: '#169499'
                            }).then(function () {
                                history.push("/motivo-situacao/" + res.data.id);
                            });
                            actions.setSubmitting(false);
                        }).catch((error => {
                            actions.setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                            actions.setSubmitting(false);
                        }))

                    }, 200)
                }}>
                {(props) => (
                    <Flex
                        flexDir="column"
                        mt={5}>
                        <Form>
                            <FocusError />
                            <Flex>
                                <Group bgColor="#fff" title="" py="12px" >
                                    <Box width={{ lg: '50%' }}>
                                        <Flex>
                                            <Field name="tipoSituacaoId">
                                                {({ field, form }) => (
                                                    <FormControl isInvalid={form.errors.tipoSituacaoId && form.touched.tipoSituacaoId}>
                                                        <FormLabel htmlFor="tipoSituacaoId">Tipo de Situação*</FormLabel>
                                                        <Select
                                                            {...field}
                                                            id="tipoSituacaoId"
                                                            backgroundColor={"white"}
                                                            placeholder={"Selecione o Tipo de Situação"}
                                                            h="42px"
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                form.setFieldValue(field.name, value);

                                                                if (value === "2") {
                                                                    form.setFieldValue("riscoVida", []);
                                                                    form.setFieldValue("extincaoPoderFamiliar", [])
                                                                }
                                                            }}
                                                        >
                                                            <option value={"1"}>Acolhido</option>
                                                            <option value={"2"}>Desligado</option>

                                                        </Select>
                                                        <FormErrorMessage>{form.errors.tipoSituacaoId}</FormErrorMessage>
                                                    </FormControl>

                                                )}
                                            </Field>
                                        </Flex>
                                        <Flex mt={5}>
                                            <Field name="descricao">
                                                {({ field, form }) => (
                                                    <FormControl isInvalid={form.errors.descricao && form.touched.descricao}>
                                                        <FormLabel htmlFor="descricao">Descrição*</FormLabel>
                                                        <Input
                                                            autoFocus
                                                            {...field}
                                                            id="descricao"
                                                            backgroundColor="white"
                                                            placeholder="Informe a Descrição do Motivo de Situação"
                                                            maxLength={255}
                                                            onChange={(e) => {
                                                                setDescricaoCount(e.target.value.length);
                                                                form.setFieldValue(field.name, e.target.value);
                                                            }}
                                                            h="42px"
                                                        />
                                                        <FormErrorMessage>{form.errors.descricao}</FormErrorMessage>
                                                    </FormControl>

                                                )}
                                            </Field>
                                        </Flex>
                                        <Flex flexDirection="row-reverse">
                                            <Tag maxW="max-content">{`${descricaoCount}/255`}</Tag>
                                        </Flex>
                                        <Flex flexDirection="column">
                                            <Field name="riscoVida">
                                                {({ field, form }) => (
                                                    <FormControl
                                                        id="riscoVida"
                                                        width="max-content"
                                                    >
                                                        <ChakraProvider theme={theme}>
                                                            <Checkbox
                                                                {...field}
                                                                value="Possui"
                                                                name="riscoVida"
                                                                id="riscoVida"
                                                                whiteSpace="nowrap"
                                                                isChecked={props.values.riscoVida.includes("Possui") ? true : false}
                                                                onChange={(e) => {
                                                                    form.setFieldValue(
                                                                        field.name,
                                                                        e.target.checked ? "Possui" : ""
                                                                    );
                                                                }}
                                                                disabled={props.values.tipoSituacaoId === "2"}
                                                            >
                                                                Risco de Vida
                                                            </Checkbox>
                                                        </ChakraProvider>
                                                        <FormErrorMessage>{form.errors.riscoVida}</FormErrorMessage>
                                                    </FormControl>
                                                )}
                                            </Field>
                                            <Field name="extincaoPoderFamiliar">
                                                {({ field, form }) => (
                                                    <FormControl
                                                        id="extincaoPoderFamiliar"
                                                        width="max-content"
                                                    >
                                                        <ChakraProvider theme={theme}>
                                                            <Checkbox
                                                                {...field}
                                                                value="Possui"
                                                                name="extincaoPoderFamiliar"
                                                                id="extincaoPoderFamiliar"
                                                                whiteSpace="nowrap"
                                                                isChecked={props.values.extincaoPoderFamiliar.includes("Possui") ? true : false}
                                                                onChange={(e) => {
                                                                    form.setFieldValue(
                                                                        field.name,
                                                                        e.target.checked ? "Possui" : ""
                                                                    );
                                                                }}
                                                                disabled={props.values.tipoSituacaoId === "2"}
                                                            >
                                                                Houve Extinção do Poder Familiar?
                                                            </Checkbox>
                                                        </ChakraProvider>
                                                        <FormErrorMessage>{form.errors.extincaoPoderFamiliar}</FormErrorMessage>
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </Flex>
                                        <Flex mt={5}>
                                            <Field name="conceito">
                                                {({ field, form }) => (
                                                    <FormControl isInvalid={form.errors.conceito}>
                                                        <FormLabel htmlFor="conceito">Conceito*</FormLabel>
                                                        <Textarea
                                                            {...field}
                                                            backgroundColor="white"
                                                            id="conceito"
                                                            placeholder="Informe o Conceito"
                                                            maxLength={4000}
                                                            onChange={(e) => {
                                                                setConceitoCount(e.target.value.length);
                                                                form.setFieldValue(field.name, e.target.value);
                                                            }}
                                                        />
                                                        <FormErrorMessage>{form.errors.conceito}</FormErrorMessage>
                                                    </FormControl>

                                                )}
                                            </Field>
                                        </Flex>
                                        <Flex flexDirection="row-reverse">
                                            <Tag maxW="max-content">{`${conceitoCount}/4000`}</Tag>
                                        </Flex>

                                    </Box>
                                </Group>
                            </Flex>
                            <Flex mt={2} justifyContent="space-between">
                                <Flex></Flex>
                                <Button
                                    mt={4}
                                    colorScheme="teal"
                                    px={16}
                                    isLoading={props.isSubmitting}
                                    type="submit"
                                    translate="no">
                                    Salvar
                                </Button>
                            </Flex>

                        </Form>
                    </Flex>
                )}
            </Formik>
        </Flex>
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    )
}

export default CadastrarMotivoSituacao;